import React, { PureComponent } from "react";
import styled from "styled-components";

import { Button as ButtonText } from "../Typography";

import PlayNowButton from "components/Header/PlayNowButton";

const Buttons = styled.div`
  margin-left: auto;
  margin-right: auto;
  padding: 1rem 2rem;
  text-align: center;
  flex-direction: column;
  position: relative;
  z-index: 1;


  button {
    width: 100%;

    img {
      width: 100%;
    }
  }

  ${ButtonText} {
    font-weight: bolder;
    font-size: 1.5rem;
  }

  .join-discord {
    display: none;
  }

  @media (max-width: 750px) {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    bottom: 4rem;
    padding: 0;
    
    .button {
      width: 100%;
      margin-bottom: 1rem;
      display: none;
    }

    .join-discord {
      border-radius: 0.25rem;
      display: inline-block;
      width: 100%;
      border-color: var(--dark);
      color: #fff;

      span {
        color: var(--dark);
      }
      svg {
        fill: var(--dark);
      }
    }
  }

  .content {
    padding: 18px 0 6px 0;
  }

  .login {
    color: #fff;
    font-weight: 700;
    font-size: 12px;
    cursor: pointer;
    text-decoration: underline;
  }
`;

export default class ButtonsEl extends PureComponent {
  render() {
    return (
      <Buttons>
        <div className="button">
          <PlayNowButton />
        </div>
      </Buttons>
    );
  }
}
